module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-toyota.58ee7463.png";